"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLogger = void 0;
var loggerFactory_1 = require("./loggerFactory");
Object.defineProperty(exports, "createLogger", { enumerable: true, get: function () { return loggerFactory_1.createLogger; } });
//# sourceMappingURL=index.js.map